<template>
  <zm-select
    data-testid="checkout-select-42"
    ref='select'
    v-model="innerValue"
    v-bind="$attrs"
    @update:modelValue="handleSelectInput"
    @change="handleChange"
  >
    <template v-for="(_, slot) in $slots" :key="slot" #[slot]="scope">
      <slot :name="slot" v-bind="scope"></slot>
    </template>
  </zm-select>
</template>

<script>
export default {
  name: 'zb-select',
  emits: ['update:modelValue', 'change'],
  data() {
    return {
      innerValue: '',
      nextValue: ''
    };
  },
  props: {
    modelValue: [String, Number, Boolean, Array],
    action: Function,
  },
  methods: {
    handleSelectInput(value) {
      this.$nextTick(async () => {
        this.nextValue = value;
        this.innerValue = this.modelValue;
        if(this.action) {
          await this.action.call(this, this.modelValue, this.nextValue);
        }
        this.$emit('update:modelValue', this.nextValue);
        this.innerValue = this.nextValue;
        this.$emit('change', this.nextValue);
      })
    },
    handleChange(value) {
      this.$emit('change', value);
    },
    focus() {
      this.$refs.select.focus();
    }
  },
  watch: {
    modelValue: {
      immediate: true,
      handler() {
        this.innerValue = this.modelValue;
      },
    }
  }
}
</script>
